import type { AuthResponse } from '~/interfaces/common';
import { fetchJson } from '~/utils/fetch-json';
import { removeLocalStorageItem } from '~/utils/local-storage';

export abstract class SignupHandler<E = unknown, T = unknown> {
  #originName!: string;

  constructor(originName: string) {
    this.#originName = originName;
  }

  protected abstract transformRequestBody(body: E): T;

  private async sendSignupRequest(body: T) {
    const res = await fetchJson<AuthResponse>(
      `/origins/${this.#originName}/register`,
      {
        method: 'POST',
        body: JSON.stringify(body),
      },
    );
    if (res) {
      removeLocalStorageItem('originName');
      removeLocalStorageItem('signup');
    }

    return res;
  }

  public async handle(body: E) {
    const transformedBody = this.transformRequestBody(body);
    return this.sendSignupRequest(transformedBody);
  }
}
